import { render, staticRenderFns } from "./IconMaterial.vue?vue&type=template&id=28cd64c0&scoped=true&"
import script from "./IconMaterial.vue?vue&type=script&lang=js&"
export * from "./IconMaterial.vue?vue&type=script&lang=js&"
import style0 from "./IconMaterial.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./IconMaterial.vue?vue&type=style&index=1&id=28cd64c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28cd64c0",
  null
  
)

export default component.exports